/**
 * 自動載入產品資料，替代內聯 crossJson 腳本
 * 避免 CSP (Content Security Policy) 問題
 */ // 產品到 JSON 檔案的映射表
const productJsonMap = {
    'tinker-v': 'tinker-v',
    'tinker-board-s-r2': 'board-s-r2',
    'tinker-board-3N-lite': 'board-3n-lite',
    'tinker-board': 'board',
    'tinker-board-2s': 'board-2s',
    'tinker-edge-t': 'edge-t',
    'tinker-board-3s': 'board-3s',
    'tinker-board-3': 'board-3',
    'board-3': 'board-3',
    'tinker-board-r2': 'board-r2',
    'tinker-system-3N': 'system-3n',
    'tinker-board-2': 'board-2',
    'tinker-edge-r': 'edge-r',
    'tinker-system-2': 'system-2',
    'tinker-board-3N': 'board-3n',
    'tinker-board-3N-plus': 'board-3n-plus',
    'tinker-board-s': 'board-s',
    'PP-156W-3399': 'pp-156w-3399',
    'PP-101W-3399': 'pp-101w-3399',
    'PP-156W-3568': 'pp-156w-3568',
    'poe-splitter-board': 'poe-splitter-bord',
    'mipi-converter': 'mipi-converter'
};
// 自動載入產品資料
function autoLoadProductData() {
    const body = document.body;
    const productKey = body.dataset.product;
    if (!productKey) return;
    const jsonFile = productJsonMap[productKey];
    if (!jsonFile) {
        console.warn(`\u{672A}\u{627E}\u{5230}\u{7522}\u{54C1} "${productKey}" \u{7684} JSON \u{6620}\u{5C04}`);
        return;
    }
    // crossJson 函數會自動加上 /data/ 前綴，所以只需要傳入檔案名稱
    console.log(`\u{7522}\u{54C1} JSON \u{6A94}\u{6848}: ${jsonFile}`);
    // 載入規格資料 (如果頁面有規格表格)
    if (document.getElementById('table--sp')) {
        const specFile = jsonFile + '.json';
        console.log(`\u{8F09}\u{5165}\u{898F}\u{683C}\u{8CC7}\u{6599}: ${specFile}`);
        if (typeof crossJson === 'function') crossJson(specFile, 'spec');
    }
    // 載入圖庫資料 (如果頁面有圖庫容器)
    if (document.getElementById('gallery_row')) {
        const galleryFile = jsonFile + '-gallery.json';
        console.log(`\u{8F09}\u{5165}\u{5716}\u{5EAB}\u{8CC7}\u{6599}: ${galleryFile}`);
        if (typeof crossJson === 'function') crossJson(galleryFile, 'gallery');
    }
}
// DOM 載入完成後自動執行
document.addEventListener('DOMContentLoaded', autoLoadProductData);
// 匯出給需要手動呼叫的情況
window.autoLoadProductData = autoLoadProductData;

//# sourceMappingURL=main.764c6f93.js.map
